import { render } from "./MoRDashboard.vue?vue&type=template&id=35faee80&scoped=true"
import script from "./MoRDashboard.vue?vue&type=script&lang=js"
export * from "./MoRDashboard.vue?vue&type=script&lang=js"

import "./MoRDashboard.vue?vue&type=style&index=0&id=35faee80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35faee80"]])

export default __exports__